import { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routing";

import "react-whatsapp-chat-widget/index.css";
import "./App.css";

import { UserProvider } from "./context/userContext";
import { Toaster } from "react-hot-toast";

function App() {
  const [token, setToken] = useState(false);

  return (
    <div className="notranslate" translate="no">
      <UserProvider>
        <Router>
          <AppRoutes token={token} setToken={setToken} />
          <Toaster />
        </Router>
      </UserProvider>
    </div>
  );
}

export default App;
